module.exports = __webpack_public_path__ + "img/appAsset-brand--getnet.2d777a5f.svg";